import React, { useState, useContext } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { authService } from '../services/authService';
import { AuthContext } from '../context/AuthContext';
import Layout from '../components/Layout';

const ClaimChimney = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const { refreshUser } = useContext(AuthContext);
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) {
      setError('Hasło musi mieć co najmniej 8 znaków');
      return;
    }
    if (password !== passwordConfirm) {
      setError('Hasła nie są identyczne');
      return;
    }
    setLoading(true);
    try {
      await authService.confirmClaimChimney(uid, token, password, passwordConfirm);
      refreshUser();
      setSuccess(true);
      setTimeout(() => navigate('/chimney-dashboard'), 1500);
    } catch (err) {
      const d = err.response?.data;
      setError(
        d?.error || d?.password?.[0] || d?.password_confirm?.[0] ||
          'Nie udało się ustawić hasła. Link mógł wygasnąć – poproś o nowy.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full">
          {success ? (
            <div className="bg-white rounded-lg shadow-md p-8 text-center">
              <div className="text-green-600 text-4xl mb-4">✓</div>
              <h2 className="text-2xl font-bold text-ik-black mb-4">Hasło ustawione</h2>
              <p className="text-gray-600">Zostałeś zalogowany. Przekierowujemy do panelu kominiarza...</p>
            </div>
          ) : (
            <div className="bg-white rounded-lg shadow-md p-8">
              <h2 className="text-2xl font-bold text-ik-black mb-2">Przejmij swój wpis</h2>
              <p className="text-gray-600 text-sm mb-6">
                Ustaw hasło do konta powiązanego z Twoim wpisem w bazie. Potem będziesz mógł się logować i edytować profil.
              </p>
              <form onSubmit={handleSubmit} className="space-y-4">
                {error && (
                  <div className="bg-red-50 border border-red-400 text-red-700 px-4 py-3 rounded text-sm">
                    {error}
                  </div>
                )}
                <div>
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                    Nowe hasło *
                  </label>
                  <input
                    id="password"
                    type="password"
                    required
                    minLength={8}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="appearance-none relative block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-ik-orange focus:border-ik-orange sm:text-sm"
                    placeholder="Min. 8 znaków"
                  />
                </div>
                <div>
                  <label htmlFor="passwordConfirm" className="block text-sm font-medium text-gray-700 mb-1">
                    Powtórz hasło *
                  </label>
                  <input
                    id="passwordConfirm"
                    type="password"
                    required
                    value={passwordConfirm}
                    onChange={(e) => setPasswordConfirm(e.target.value)}
                    className="appearance-none relative block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-ik-orange focus:border-ik-orange sm:text-sm"
                    placeholder="Powtórz hasło"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-2 px-4 bg-ik-orange text-white rounded-md hover:bg-orange-600 transition font-medium disabled:opacity-50"
                >
                  {loading ? 'Zapisywanie…' : 'Ustaw hasło i przejmij wpis'}
                </button>
              </form>
              <p className="mt-4 text-center text-sm text-gray-500">
                <Link to="/login" className="text-ik-orange hover:underline">Wróć do logowania</Link>
              </p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ClaimChimney;
